import Vue from "vue";
import {api} from "@/store/resources";

export default {
    namespaced: true,
    state: {
        notificationsSettings: [],
    },
    getters: {},
    actions: {
        async fetchNotificationsSettings({commit}) {
            try {
                const res = await api.user_notifications.get();
                if (res.body.success) {
                    commit('setNotificationsSettings', res.body.data)
                }
            } catch (err) {
                console.error(err);
            }
        },
        async updateNotificationSetting({commit}, setting) {
            try {
                commit('updateNotificationSetting', setting)
                const res = await api.user_notifications.update({id: setting.id}, {...setting});
            } catch (err) {
                console.error(err);
            }

        }
    },
    mutations: {
        setNotificationsSettings(state, data) {
            state.notificationsSettings = data;
        },
        updateNotificationSetting(state, newSetting) {
            let settingIndex = state.notificationsSettings.findIndex(setting => setting.id === newSetting.id);
            Vue.set(state.notificationsSettings, settingIndex, newSetting);
        }
    }
}